const UserStatus = {
    ACTIVE: 1,
    DISABLED: 2,
    PENDING: 3
}

const getUserStatusText = (status) => {
    switch(status) {
        case UserStatus.ACTIVE:
            return 'Active';
        case UserStatus.DISABLED:
            return 'Disabled';
        case UserStatus.PENDING:
            return 'Pending';
        default:
            return 'Unknown';
    }
}

export { getUserStatusText };
export default UserStatus; 